// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-div {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background: rgba(255, 255, 255, 0.8);
  }
  .circular-progress {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .loading {
    opacity: 0.5;
    transition: opacity 0.3s ease-in-out;
  }
  
  .not-loading {
    opacity: 1;
    transition: opacity 0.3s ease-in-out;
  }
  
  .grid-item-button-div{
    margin-top: 20px;
  }`, "",{"version":3,"sources":["webpack://./src/Pages/tagging/form.css"],"names":[],"mappings":"AAAA;IACI,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,oCAAoC;EACtC;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;EACA;IACE,YAAY;IACZ,oCAAoC;EACtC;;EAEA;IACE,UAAU;IACV,oCAAoC;EACtC;;EAEA;IACE,gBAAgB;EAClB","sourcesContent":[".spinner-div {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 9999;\n    background: rgba(255, 255, 255, 0.8);\n  }\n  .circular-progress {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n  .loading {\n    opacity: 0.5;\n    transition: opacity 0.3s ease-in-out;\n  }\n  \n  .not-loading {\n    opacity: 1;\n    transition: opacity 0.3s ease-in-out;\n  }\n  \n  .grid-item-button-div{\n    margin-top: 20px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
